export const STATUS_TYPES = {
  '0': '新建',
  '1': '操作成功',
  '2': '已删除',
  '-1': '操作失败'
};
